// extracted by mini-css-extract-plugin
export default {"projectSection":"styles_projectSection__rsYnl","projectWrpper":"styles_projectWrpper__HH1On","projectsContainer":"styles_projectsContainer__DeI0v"};